import t from "./generateUtilityClasses.mjs";
const e = t("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), i = e;
export {
  i as default
};
//# sourceMappingURL=listItemButtonClasses.mjs.map
